export default __webpack_public_path__ + "static/media/gilroy-bold-4.a64a9abe.otf";